import { proxy } from "valtio";
import {Todo} from "@models/todo.model.ts";


export const todoStore = proxy({
    selectedTodo: new Todo(),
})


